import { tv } from 'tailwind-variants'

export const wave = tv({
  base: 'w-full',
  variants: {
    flipY: { true: 'rotate-180 scale-x-[-1]' },
    flipX: { true: 'rotate-180 scale-y-[-1]' },
  },
})
